// #region Imports

import * as $ from "jquery";
import * as AutoLoadOnScroll from "./navigation/autoLoadOnScroll";
import * as BrowserHistory from "./helpers/browserHistory";
import * as LoadMore from "./loadMore";
import { setNewDictionaryToQuery } from "./helpers/setNewDictionaryToQuery";
import { getUrlParameter } from "./helpers/urlParameter";

// #endregion Imports

// #region Exports

export function initialize(): void {
    bindInputs();
    markBodyTag()
}

// #endregion Exports

// #region Private constants

const inputSelector = ".js-trigger-product-filter";
const MOBILE_EXPANDED_CLASSNAME = "mobile-navigation__item--expanded-right";

// #endregion Private constants

// #region Global state

let timeout;

// #endregion Global state

// #region Private functions

function bindInputs(): void {
  $('[data-remove-filter]').on("click", removeSelectedFilter);
  $(inputSelector).on("click keydown change", handleEvent);
  $(".js-show-filter").on("click", toggleMobileFilter);
  $(".js-reset-query-filter").on("click", resetQuery);
  $(".js-scroll-top").on("click", scrollTop);
  $("#mobileModalButton").on("click keydown", openFilterModal);
  $("#product-filter-dropdown").on("click", handleProductFilterDropdown);
  $("#productlist-sorting .dropdown__title, #productlist-sorting .dropdown__link").on("click", handleProductListSorting);
  $(".clear-search").on("click", resetEobQuery);
}

$(document).mouseup(function (e) {
    var container = $(".product-filter-mobile-modal.modal-open");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        closeMobileFilterModal();
    }
});

window.onclick = function (e) {
    var ddProductlistSorting = $("#productlist-sorting");
    if (!ddProductlistSorting.is(e.target) && ddProductlistSorting.has(e.target).length === 0) {
        closeFilterDropdown();
    }
    var ddProductFilter = $(".product-filter__dropdown-wrapper");
    if (!ddProductFilter.is(e.target) && ddProductFilter.has(e.target).length === 0) {
        closeProductFilterDropdown();
    }
}

document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
        closeFilterDropdown();
        resetEobQuery(e);
        if (document.body.classList.contains('filter-modal-open')) {
            closeFilterDropdown();
        }
        if (document.body.classList.contains('modal-open')) {
            document.body.classList.remove("modal-open")
            $('.js-aria-state').attr('aria-pressed', false);
        }
    }
});

document.addEventListener("keyup", () => {
    var item = document.getElementById('eob-search-input');
    if (typeof (item) != 'undefined' && item != null) {
        if ($("#eob-search-input").val().length > 0) {
            $('.product-filter__input-wrapper .clear-search').removeClass('hidden');
        } else {
            $('.product-filter__input-wrapper .clear-search').addClass('hidden');
        }
    }
});

function resetEobQuery(e) {
    e.preventDefault();
    var item = document.getElementById('eob-search-input');
    if (typeof (item) != 'undefined' && item != null) {
        $("#eob-search-input").val("");
        $("html, body").animate({ scrollTop: 0 }, 250);
        $("#eob-search").submit();
    }
}

function closeMobileFilterModal() {
    const modalIsOpened = $(".product-filter-mobile-modal").hasClass('modal-open');
    if (modalIsOpened) {
        $('body').removeClass('filter-modal-open').removeClass('modal-open');
        $('.product-filter-mobile-modal').removeClass('modal-open');
        $('.mobile-modal-overlay').remove();
        $('#mobileModalButton.js-aria-state').attr('aria-pressed', false);
    }
}

function handleProductFilterDropdown(e: any) {
    e.preventDefault();
    const $this = $(this);
    const newState = ($this.attr('aria-pressed') === 'false');

    $this.attr('aria-pressed', (newState) as any);
    $this.trigger('aria-pressed', [
        {
            state: {
                pressed: newState
            }
        }
    ]);

    if (newState === false) {
        document.body.classList.remove("modal-open")
    } else {
        document.body.classList.add("modal-open")
    }
}

function closeFilterDropdown() {
    const $item = $("#productlist-sorting .dropdown__title");
    const isOpened = $item.hasClass('dropdown__title--open');
    if (isOpened) {
        document.body.classList.remove("modal-open");
        document.body.classList.remove("productlist-sorting-open");
        $('#productlist-sorting .dropdown__title').removeClass('dropdown__title--open');
        $('#productlist-sorting .dropdown__list').removeClass('dropdown__list--open');
    }
}

function handleProductListSorting() {
    const $item = $("#productlist-sorting .dropdown__title");
    const isOpened = $item.hasClass('dropdown__title--open');
    if (isOpened) {
        $('.dropdown__title').attr('aria-expanded', true);
        document.body.classList.add("productlist-sorting-open");
    } else {
        $('.dropdown__title').attr('aria-expanded', false);
        document.body.classList.remove("productlist-sorting-open");
    }
}

function closeProductFilterDropdown(e) {
    document.body.classList.remove("modal-open")
    $('#product-filter-dropdown').attr('aria-pressed', false);
}

function openFilterModal(event) {
    event.preventDefault();
    const $item = $(".product-filter-mobile-modal");
    const isOpened = $item.hasClass('modal-open');

    if (isOpened) {
        closeMobileFilterModal();
    } else {
        $('body').addClass('filter-modal-open');
        $('.product-filter-mobile-modal').addClass('modal-open');
        $('.product-filter-mobile-modal').before("<div class='mobile-modal-overlay'></div>");
    }
}

function markBodyTag() {
    $('body').addClass('js-dictionary');
}

function isBlockEvent(event: any): boolean {
  return (
    (event.type === "change" && event.target.type === "text") ||
    (event.type === "click" && event.target.classList.contains("product-filter__input"))
  );
}

function resetQuery(event) {
  event.preventDefault();
  $(".product-filter__input").val("");
  $("html, body").animate({ scrollTop: 0 }, 250);
  $(this).closest("form").submit();
}

function scrollTop(event) {
  event.preventDefault();
  $("html, body").animate({ scrollTop: 0 }, 250);
}

function toggleMobileFilter(event) {
  event.stopImmediatePropagation();

  const $item = $(".mobile-navigation__item--right");
  const isExpanded = $item.hasClass(MOBILE_EXPANDED_CLASSNAME);

  if (isExpanded) {
    $item.removeClass(MOBILE_EXPANDED_CLASSNAME);
    $(".product-filter").removeClass("product-filter--open");
  } else {
    $item.addClass(MOBILE_EXPANDED_CLASSNAME);
    $(".product-filter").addClass("product-filter--open");
    $(".product-filter__input").focus();
  }
}

function removeSelectedFilter(event): void {
  const filterValue = $(this).data('remove-filter');
  const filterInput = $(`[data-filter='${filterValue}']`);
  if(filterInput) {
    filterInput.prop('checked', false);
    handleAjax(event);
  }
}

function handleEvent(event): void {
  if (isBlockEvent(event)) {
    return;
  }

  clearTimeout(timeout);
  timeout = setTimeout(() => handleAjax(event), 250);
}

function handleAjax(event: any): void {
  const $form = $(event.target).closest("form");
  const form: any = $form.get(0);
  let serializedData = $form.serialize();
  if (event.target.classList[0] === "swap-icon") {    
    serializedData = setNewDictionaryToQuery(serializedData);
    updateEOBInputPlaceholderBasedOnDictionary()
  }
  BrowserHistory.replaceEntry(`${form.action}?${serializedData}`);
  $("html, body").animate({ scrollTop: 0 }, 250);
  $.ajax({
    url: form.dataset.ajaxurl,
    type: form.method,
    data: serializedData,
    success: handleData,
  });
}

function updateEOBInputPlaceholderBasedOnDictionary() {
  const currentDictionary = getUrlParameter("dictionary");
  let newPlaceholder = "Sök på svenska ord och begrepp";
  if(currentDictionary == 'sv') {
      newPlaceholder = 'Sök på engelska ord och begrepp';
  }
  const $eobSearchInput = $('#eob-search-input');
  if($eobSearchInput) {
    $eobSearchInput.attr("placeholder", newPlaceholder);
  }
}

function handleData(data: any): void {
    const productListWrapperIdentifier = "#productlist-wrapper";
    const resultHeadingIdentifier = "#productlist-heading";
    const sortingIdentifier = "#productlist-sorting";
    const selectedFiltersIdentifier = "#productlist-selected-filters";
    const noOfFiltersIdentifier = "#product-filter__no-of-filters";

    const $data = $(`<div>${data}</div>`);
    const $list = $(productListWrapperIdentifier);
    const $sorting = $(sortingIdentifier);
    const $resultHeading = $(resultHeadingIdentifier);
    const noOfFilters = $(noOfFiltersIdentifier);
    const $selectedFilters = $(selectedFiltersIdentifier);

    const $newList = $data.find(productListWrapperIdentifier);
    const $newResultHeading = $data.find(resultHeadingIdentifier);
    const $newNoOfFilters = $data.find(noOfFiltersIdentifier);
    const $newSorting = $data.find(sortingIdentifier);
    const $newSelectedFilters = $data.find(selectedFiltersIdentifier);
    const $newViewmore = $data.find("#viewmore");

    //Add event listeners
    $newList.find(".js-trigger-product-filter").on("click", handleEvent);
    $newSelectedFilters.find('[data-remove-filter]').on("click", removeSelectedFilter);

    //Setting the dictionary in the form and not only in the ajaxcall
    const currentDictionary = $data.find(".dictionary__source").value;
    $newList.find("#DictionaryValue").value = currentDictionary;

    $list.replaceWith($newList);
    $resultHeading.replaceWith($newResultHeading);
    noOfFilters.replaceWith($newNoOfFilters);
    $selectedFilters.replaceWith($newSelectedFilters);
    $sorting.attr("class", $newSorting.attr("class"));

    LoadMore.initialize($newViewmore.find("a"));

    AutoLoadOnScroll.initialize();
}

// #endregion Private functions
